<script lang="ts">
  import Link from "./components/Link.svelte";
  import type { NostrEvent } from "@nostr/tools";
  import {
    addedLabels,
    counts,
    topics as globalTopics,
    lastcomment
  } from "./relay.svelte";
  import { write } from "./components/WriteArea.svelte";
  import { formatDate, getTitle } from "./utils";
  import type { RouteResult } from "@mateothegreat/svelte5-router";

  let { route }: { route: RouteResult } = $props();
  const byComment = route.result.path.original === "/c";

  const topics = $derived(
    byComment
      ? globalTopics.toSorted(
          (a, b) => lastcomment[b.id].created_at - lastcomment[a.id].created_at
        )
      : globalTopics
  );

  function* getLabels(topic: NostrEvent) {
    let emitted: string[] = [];
    for (let i = 0; i < topic.tags.length; i++) {
      if (
        topic.tags[i][0] === "t" &&
        topic.tags[i][1] &&
        !emitted.includes(topic.tags[i][1])
      ) {
        yield topic.tags[i][1];
        emitted.push(topic.tags[i][1]);
      }
    }

    const added = addedLabels[topic.id] || [];
    for (let i = 0; i < added.length; i++) {
      if (!emitted.includes(added[i])) {
        yield added[i];
        emitted.push(added[i]);
      }
    }
  }
</script>

<div class="py-6">
  <header class="mb-8">
    <div class="flex items-center justify-between">
      <h1 class="text-2xl font-medium">Recent Topics</h1>
      <button
        class="cursor-pointer rounded bg-gray-800 px-4 py-2 text-sm text-white hover:bg-gray-700 dark:bg-gray-700 dark:hover:bg-gray-600"
        onclick={() => write()}
      >
        New Topic
      </button>
    </div>
  </header>

  <main>
    <div class="space-y-px">
      {#each topics as topic}
        <Link target="/topic/{topic.id}" class="hover:underline">
          <article
            class="group cursor-pointer border-b border-gray-100 bg-white px-6 py-4 hover:bg-gray-50 dark:border-gray-800 dark:bg-gray-800/50 dark:hover:bg-gray-800"
          >
            <div class="flex items-start justify-between gap-4">
              <div class="min-w-0 flex-1">
                <h2 class="mb-1 truncate text-lg font-medium">
                  {getTitle(topic)}
                </h2>
                <div
                  class="mt-2 flex items-center gap-3 text-xs text-gray-500 dark:text-gray-500"
                >
                  <a
                    class="hover:text-gray-900 dark:hover:text-gray-300"
                    target="_blank"
                    aria-label="external link to see author's profile"
                    href="https://njump.me/p/{topic.pubkey}"
                    ><nostr-name pubkey={topic.pubkey}></nostr-name></a
                  >
                  <span>{formatDate(topic.created_at)}</span>
                  <span
                    >{#if counts[topic.id] > 1}{counts[topic.id]} replies{/if}</span
                  >
                  {#each getLabels(topic) as label}
                    <span
                      class="rounded-full bg-gray-100 px-2 py-0.5 dark:bg-gray-800"
                      >{label[1].toUpperCase()}</span
                    >{/each}
                </div>
              </div>
            </div>
          </article>
        </Link>
      {/each}
    </div>
  </main>
</div>
